<template>
  <div v-if="page">
    <page-view :page="page.post" />
    <post-details :page="page.post" />
    <v-toolbar dense>
      <v-btn
        raised
        router
        ripple
        v-if="page.previous_url"
        :color="baseColor"
        :title="$store.getters.getLangKey('previousPost')"
        :to="{name: 'PostPage', params: createRouteFromUrl(page.previous_url)}"
      >
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <v-spacer />
      <v-btn
        raised
        router
        ripple
        v-if="page.next_url"
        :color="baseColor"
        :title="$store.getters.getLangKey('nextPost')"
        :to="{name: 'PostPage', params: createRouteFromUrl(page.next_url)}"
      >
        <v-icon>chevron_right</v-icon>
      </v-btn>
    </v-toolbar>
  </div>
</template>
<script>
  import Mixins from '../helpers/Mixins'
  import TagsList from '../components/TagsList.vue'
  import CategoriesList from '../components/CategoriesList.vue'
  import PostDetails from '../components/PostDetails.vue'
  import Filters from '../helpers/Filters'
  import PageView from '../components/PageView.vue'

  export default {
    name: 'PostPage',
    mixins: [
      Mixins
    ],
    components: {
      TagsList,
      CategoriesList,
      PageView,
      PostDetails
    },
    data () {
      return {
        resource: '?resource=get_post&post_slug=',
        page: null,
        href: window.location.href,
        baseColor: this.$store.state.baseColor
      }
    },
    watch: {
      '$route.params.id': function () {
        this.getPostData()
      }
    },
    mounted () {
      this.getPostData()
    },
    updated () {
      this.setTitle(this.page.post.title_plain)
    },
    methods: {
      /**
       * Get, set and cache the post DTO
       * @method getPostData
       * @return void
       * **/
      getPostData () {
        const store = this.$store
        const getters = store.getters
        const base = getters.apiProxyUrl
        const id = this.$route.params.id
        const slug = `${this.resource}${id}`
        const url = `${base}${slug}`
        const page = getters.post(id)
        const ajax = store.state.events.ajax
        if (page) {
          this.page = page
          return
        }
        this.$root.$emit(ajax, true)
        this.$http(url).then(response => {
          response = response.data
          store.commit('storePost', response)
          this.page = getters.post(id)
          this.$root.$emit(ajax, false)
        })
      },
      /**
       * @using ../../filters
       */
      formatDate () {
        return Filters.formatDate()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/PostPage.vue